const formatError = (error: unknown): Error => {
  if (error instanceof Error) {
    return error;
  } else if (typeof error === "string") {
    return Error(error);
  } else if (typeof error === "object" && error !== null) {
    return Error(JSON.stringify(error));
  }

  return Error(String(error));
};

export const logError = <T>(error: unknown, context?: T): void => {
  const loggedError = formatError(error);

  if (context) {
    console.error(loggedError, context);
  } else {
    console.error(loggedError);
  }

  if (typeof ineum !== "undefined") {
    if (context) {
      ineum("reportError", loggedError, {
        meta: context,
      });
    } else {
      ineum("reportError", loggedError);
    }
  }
};

export const logComponentError = (
  error: unknown,
  componentStack: string,
): void => {
  if (typeof ineum !== "undefined") {
    const loggedError = formatError(error);
    ineum("reportError", loggedError, { componentStack });
  }
};
